import { html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import Styles from './vm-button.scss';

@customElement('vm-button')
export class VmButton extends LitElement {
    static override styles = Styles;

    @property()
    variant: string = '';

    @property()
    size: string = '';

    @property()
    custom: string = '';

    @property({ type: Boolean, reflect: true })
    disabled: boolean = false;

    @property({ type: Boolean })
    active: boolean = false;

    @property({ type: Boolean })
    override hidden: boolean = false;

    @property()
    type: 'button' | 'submit' | 'reset' | 'menu' = 'button';

    @property({ type: Boolean, attribute: 'min-width' })
    minWidth: boolean = false;

    @property({ type: Boolean, attribute: 'full-width' })
    fullWidth: boolean = false;

    @property({ type: String, attribute: 'aria-label' })
    override ariaLabel: string = '';

    get buttonClasses() {
        const classes = {
            'vm-button': true,
            [`vm-button--${this.variant}`]: !!this.variant,
            [`vm-button--${this.size}`]: !!this.size,
            'vm-button--active': this.active,
            'vm-button--min-width': this.minWidth,
            'vm-button--full-width': this.fullWidth,
            'vm-button--hidden': this.hidden,
        };

        // Support space-separated custom classes (e.g., "comment-cta thumb-up")
        if (this.custom) {
            this.custom.split(/\s+/).forEach((customClass) => {
                if (customClass) {
                    classes[`vm-button--${customClass}`] = true;
                }
            });
        }

        return classes;
    }

    override render() {
        return html`
            <button
                class=${classMap(this.buttonClasses)}
                type=${this.type}
                ?disabled=${this.disabled}
                aria-label=${this.ariaLabel || ''}
                part="button"
            >
                <slot></slot>
            </button>
        `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'vm-button': VmButton;
    }
}
